export const CREW_TIMELINE_TEXT = {
	closeBtn: 'Close',
	cancelBtn: 'Cancel',
	errorText: 'An error occurred',
	serverErrorText: 'Server Error',
};
